'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper to add a class to the given node when it is clicked,
 * and remove it after blur. This is use primarily to hide the
 * `focus` state when clicked, but preserve it when tabbed into.
 */
exports.default = _react2.default.createClass({
  displayName: 'HideFocusOnClick',

  propTypes: {
    children: _react.PropTypes.node.isRequired
  },

  render: function render() {
    var children = this.props.children;

    return children;
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/utils/HideFocusOnClick.js
// module id = 150
// module chunks = 0